import { createRouter as createTanStackRouter } from '@tanstack/react-router';
import type { AppContext } from '@/utils/headers';
import { DefaultCatchBoundary } from './components/DefaultCatchBoundary';
import { NotFound } from './components/NotFound';
import { routeTree } from './routeTree.gen';

function trimTrailingSlash(path: string) {
	return path.replace(/\/$/, '');
}

export function createRouter(context: AppContext) {
	const router = createTanStackRouter({
		basepath: import.meta.env.BASE_URL,
		defaultSsr: false,
		routeTree,
		defaultPreload: 'intent',
		// TODO: handle error. use defaultOnCatch/onError to handle error
		defaultViewTransition: {
			types: ({ fromLocation, toLocation, pathChanged }) => {
				// sometime patchanges could be false positive
				// for example when user lands on `/cabs` and then navigates by adding a search param
				// the url changes fromLocation undefined to toLocation `/cabs/?search=123` and vice versa
				if (
					!pathChanged ||
					!fromLocation ||
					trimTrailingSlash(fromLocation.pathname) ===
						trimTrailingSlash(toLocation.pathname)
				) {
					return [];
				}
				let direction = 'none';

				if (fromLocation) {
					const fromIndex = fromLocation.state.__TSR_index;
					const toIndex = toLocation.state.__TSR_index;

					direction = fromIndex > toIndex ? 'right' : 'left';
				}

				return [`slide-${direction}`];
			},
		},
		defaultErrorComponent: DefaultCatchBoundary,
		defaultNotFoundComponent: () => <NotFound />,
		context,
	});

	return router;
}

declare module '@tanstack/react-router' {
	interface Register {
		router: ReturnType<typeof createRouter>;
	}
}
